<template>
  <div class="flex items-center justify-start sm:w-full">
    <button
      class="h-10 min-h-full rounded-l-lg bg-ontick-steel-100 px-3 dark:bg-ontick-graphite-500"
      @click="$emit('confirm-search')"
    >
      <i v-html="$icons.search"></i>
    </button>
    <input
      type="text"
      class="w-full rounded-r-lg border-none bg-ontick-steel-100 placeholder-ontick-carbon-900 dark:bg-ontick-graphite-500 dark:placeholder-gray-300"
      placeholder="Buscar"
      @input="$emit('input', $event.target.value)"
      :value="value"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
    },
  },
};
</script>

<style></style>
